// Simple controller for modals that have an isOpen state and an optional object that is
// being edited by the modal.
import { useCallback, useState } from 'react';

const useEditableModal = (
	initialIsOpen: boolean = false,
	initialState = null,
) => {
	const [{ isOpen, state }, set] = useState({
		isOpen: initialIsOpen,
		state: initialState,
	});
	const open = useCallback(() => set({ isOpen: true, state: null }), []);
	const openWithState = useCallback(
		(newState: any) => set({ isOpen: true, state: newState }),
		[],
	);
	const close = useCallback(() => set({ isOpen: false, state: null }), []);
	const toggle = useCallback(
		() => set({ isOpen: !isOpen, state: null }),
		[isOpen],
	);

	return {
		isOpen,
		state,
		open,
		openWithState,
		close,
		toggle,
	};
};

export default useEditableModal;
